import React, { useEffect } from "react";
import Card from "src/components/common/card/Card";
import PageHeader from "src/components/common/PageHeader";
import DashboardLayout from "src/components/layout/dashboard/Layout";
import Breadcrumb from "src/components/ui/Breadcrumb";
import TableV2 from "src/components/ui/TableV2";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as customerActions from "src/redux/slices/customerSlice";
import { formatDateTime } from "src/utils/date-time";
import { formatCreatedBy } from "src/utils/common";

const CustomersPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const { list } = useAppSelector((state) => state.customer);

  useEffect(() => {
    dispatch(
      customerActions.getCustomersListRequest({
        page: 1,
        limit: 10,
      })
    );
  }, [dispatch]);

  return (
    <DashboardLayout
      meta={{
        title: "Customers | Invyntra Dashboard",
        description: "View and manage customer details",
        keywords: "customers, crm, invyntra, tenant",
      }}
    >
      <div className="space-y-4">
        {/* Header */}
        <PageHeader
          title="Customers"
          breadcrumbData={[
            { label: "Home", path: "/app/dashboard" },
            { label: "Customers", path: "/app/customers" },
          ]}
        />

        {/* Table */}
        <Card>
          <TableV2
            columns={[
              { key: "name", header: "Name" },
              { key: "mobile", header: "Mobile" },
              { key: "email", header: "Email" },
              { key: "address", header: "Address" },
              {
                key: "createdBy",
                header: "Created By",
                accessor: ({ row }) => formatCreatedBy(row?.createdBy),
              },
              {
                key: "createdAt",
                header: "Created At",
                accessor: ({ row }) =>
                  row.createdAt
                    ? formatDateTime(row.createdAt, "DD/MM/YYYY")
                    : "-",
              },
            ]}
            data={list?.data?.data || []}
            pagination={list?.data?.pagination}
            onPageChange={(page) =>
              dispatch(
                customerActions.getCustomersListRequest({
                  page,
                  limit: 10,
                })
              )
            }
          />
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default CustomersPage;
